if (typeof process === "undefined") {
  globalThis.process = {
    env: {}
  };
}
const __PRODUCTION__ = process.env.NODE_ENV === "production";
export { __PRODUCTION__ };